import { ChangeEvent } from "../../events/ChangeEvent";
import { Checkbox } from "../checkbox/Checkbox";
import { CheckboxProps } from "../checkbox/CheckboxProps";
import { ComponentTypes } from "../../base/ComponentTypes";
import { PrintableEvent } from "../../events/PrintableEvent";
import { SelectCheckboxTableCellMixin } from "./SelectCheckboxTableCellMixin";
import { SelectCheckboxTableCellStyles } from "./SelectCheckboxTableCellStyles";
import { SelectionType } from "../../base/SelectionMode";
import { TableCell } from "./TableCell";
import { TableCellProps } from "./TableCellProps";

export class SelectCheckboxTableCell extends SelectCheckboxTableCellMixin(TableCell) {
    static readonly FIXED_WIDTH = 50;

    constructor(props?: Partial<TableCellProps>) {
        super({
            ...props,
            id: `${props.table.id}-${props.row.index}-selectCheckbox`
        });
        this.allowDropInDesigner = false;
    }

    protected override addDefaultClassName() {
        this.element.classList.add(SelectCheckboxTableCellStyles.base);
    }

    protected override createCheckbox() {
        super.createCheckbox();
        this.syncCheckboxState();
        this.checkbox.addChangeListener((event: ChangeEvent) => this.checkboxSelectedOnChange(event));
        this.checkbox.addPrintableListener((event: PrintableEvent) => this.checkboxSelectedOnPrintable(event));
    }

    protected override get addlCheckboxProps(): Partial<CheckboxProps> {
        return { id: "checkboxSelectRow" };
    }

    private checkboxSelectedOnChange(event: ChangeEvent) {
        if (this._designer != null)
            return;
        if (event.userInitiatedChange) {
            this.table.selectRow(this.row, SelectionType.DISTINCT, event.domEvent);
        } else {
            // If checkbox gets redisplayed from live update, resync it with the table's selected rows
            this.syncCheckboxState();
        }
    }

    private syncCheckboxState() {
        this.checkbox.checked = this.table.selectedRows.includes(this.row);
    }

    private checkboxSelectedOnPrintable(event: PrintableEvent) {
        const checkbox = event.target as Checkbox;
        checkbox.printable = false;
    }
}
ComponentTypes.registerComponentType("selectcheckboxcell", {
    constructor: SelectCheckboxTableCell.prototype.constructor
});
